import { createContext } from 'react'
import { RBAC } from '@/lib/rbac'

export const RBACContext = createContext<{
  rbac: RBAC
  idCompanies: string[]
  rolesInCompany: string[]
  totalServices: {
    totalApps: number
    totalPipelines: number
    totalDatabases: number
    totalStaticSites: number
    totalObjectStorages: number
    totalLoadBalancers: number
    totalProjects: number
  }
}>({
  rbac: RBAC.createWithPermissions([]),
  idCompanies: [],
  rolesInCompany: [],
  totalServices: {
    totalApps: 0,
    totalPipelines: 0,
    totalDatabases: 0,
    totalStaticSites: 0,
    totalObjectStorages: 0,
    totalLoadBalancers: 0,
    totalProjects: 0,
  },
})
